import {TranslationFunction} from "../../../../../store/localization/TranslMessasge";
import { DataTypeTranslationKey } from "../DataTypeTranslationKey";
import {ConstraintType} from "../../../../../common/apis/datatype/DataTypeConstraintDto";

export class ConstraintTypeFormatter {
    static formatConstraintType(constraintType: ConstraintType | string | undefined | null, t: TranslationFunction) {
        if (!constraintType) {
            return "";
        }
        return t(DataTypeTranslationKey.CONSTRAINT_TYPE + "." + constraintType);
    }
}
